// 9fbef606107a605d69c0edbcd8029e5d
import React from 'react';
import PropTypes from 'prop-types';
import {
  TileSkeleton,
  ImageSkeleton,
  CarouselWrapper,
  SkeletonSlide,
  FullInGridRow,
  DoubleInGrid,
  SkeletonItemSlide,
  SkeletonCarouselImage,
} from '../styles/SkeletonLoader.style';

const SkeletonLoader = ({
  isEspotTile,
  isFullRowView,
  aspectRatioObj,
  isCarouselView,
  isTopPromoConfig,
  isDoubleTileGridView,
  isDoubleGridSingleTile,
}) => {
  if (isTopPromoConfig) {
    return (
      <CarouselWrapper>
        {[...Array(5)].map((_, index) => (
          <SkeletonItemSlide key={`carousel-item-${index}`}>
            <SkeletonCarouselImage />
          </SkeletonItemSlide>
        ))}
      </CarouselWrapper>
    );
  }

  if (isFullRowView) {
    return isCarouselView ? (
      <CarouselWrapper>
        {[...Array(5)].map((_, index) => (
          <SkeletonSlide key={`carousel-item-${index}`}>
            <SkeletonCarouselImage />
          </SkeletonSlide>
        ))}
      </CarouselWrapper>
    ) : (
      <FullInGridRow aspectRatioObj={aspectRatioObj}>
        <SkeletonCarouselImage />
      </FullInGridRow>
    );
  }

  if (isDoubleTileGridView) {
    return (
      <DoubleInGrid>
        {[...Array(2)].map((_, index) => (
          <TileSkeleton key={`double-item-${index}`}>
            <ImageSkeleton />
          </TileSkeleton>
        ))}
      </DoubleInGrid>
    );
  }

  return (
    <TileSkeleton isEspotTile={isEspotTile} isDoubleGridSingleTile={isDoubleGridSingleTile}>
      <ImageSkeleton />
    </TileSkeleton>
  );
};

SkeletonLoader.propTypes = {
  isEspotTile: PropTypes.bool,
  isFullRowView: PropTypes.bool,
  isCarouselView: PropTypes.bool,
  isTopPromoConfig: PropTypes.bool,
  aspectRatioObj: PropTypes.shape({}),
  isDoubleTileGridView: PropTypes.bool,
  isDoubleGridSingleTile: PropTypes.bool,
};

SkeletonLoader.defaultProps = {
  aspectRatioObj: {},
  isEspotTile: false,
  isFullRowView: false,
  isCarouselView: false,
  isTopPromoConfig: false,
  isDoubleTileGridView: false,
  isDoubleGridSingleTile: false,
};

export default SkeletonLoader;
